"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M8.5 8.62v6.76L5.12 12z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M8.5 8.62v6.76L5.12 12zM10 5l-7 7 7 7zm4 0v14l7-7z"
}, "1")], 'SwitchLeftTwoTone');